import { Input } from 'antd';
import classNames from 'classnames/bind';
import * as React from 'react';
import { IInputChangeEventArgs, InputSizes } from '../BCInput';
import Styles from './assets/styles.scss';
import { IInputPasswordProps } from './entities';
import { PasswordRefType } from './entities/IInputPasswordProps';
const cx = classNames.bind(Styles);

const BCPassword = React.forwardRef<PasswordRefType, IInputPasswordProps>(
	function BCPassword(props, ref) {
		const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			props.onChange?.(e);
		};

		const onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
			props.onFocus?.(e);
		};

		const classNames = cx({
			passwordStyles: true,
			passwordStylesWithoutButton: !props.visibilityToggle,
			textalignRight: props.textAlign === 'right',
			textalignLeft: props.textAlign === 'left',
			textalignCenter: props.textAlign === 'center',
			[props.className]: !!props.className
		});

		return (
			<Input.Password
				tabIndex={props.tabIndex}
				prefix={props.prefix}
				disabled={props.disabled}
				readOnly={props.readOnly}
				size={props.size}
				ref={ref}
				style={props.style}
				placeholder={props.placeholder}
				maxLength={props.maxLength}
				className={[classNames, props.className].join(' ')}
				onPressEnter={props.onPressEnter}
				onChange={onChange}
				onFocus={onFocus}
				type={props.type}
				addonBefore={props.addonBefore}
				addonAfter={props.addonAfter}
				onClick={props.onClick}
				onBlur={props.onBlur}
				visibilityToggle={props.visibilityToggle}
				suffix={!props.visibilityToggle && <span />} // https://ant.design/components/input#why-input-lose-focus-when-change-prefixsuffixshowcount
				allowClear={props.allowClear}
				autoComplete={props.autoComplete || 'new-password'}
				data-selenium-id={props.seleniumId}
				value={props.value}
				defaultValue={props.defaultValue}
			/>
		);
	}
);

export default BCPassword;
export { IInputChangeEventArgs, IInputPasswordProps, InputSizes, PasswordRefType };
